import { Color } from "config/colors";
import { FontFamily } from "config/font";
import { ZIndex } from "config/zIndex";
import styled from "styled-components";

type PanelProps = {
  open: boolean;
  $zIndex?: number;
};

export const InvoiceBackdrop = styled.div<PanelProps>`
  display: ${(props) => (props.open ? "block" : "none")};
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: ${(props) => (props.$zIndex ?? ZIndex.sidePanel) - 1};
`;

export const InvoicePanel = styled.div<PanelProps>`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: min(600px, 100%);
  background-color: ${Color.White};
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: ${(props) => props.$zIndex ?? ZIndex.sidePanel};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 28px 24px;
  transform: translateX(${(props) => (props.open ? "0" : "100%")});
  transition: transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1);
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  height: 50px;
`;
export const ListContainer = styled.div`
  margin-top: 20px;
`;
export const ModalBody = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  background-color: ${Color.White};
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  outline: none;
  border-radius: 8px;
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);
`;

export const FormWrapper = styled.div`
  margin-bottom: 20px;
  width: 600px;
`;
export const Row = styled.div`
  display: grid;
  grid-auto-flow: column;
  width: 100%;
  align-items: center;
  gap: 1rem;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

type RadioProps = {
  checked: boolean;
};

type RowWrapperProps = {
  view?: string;
};

export const RowWrapper = styled.div<RowWrapperProps>`
  display: flex;
  flex-direction: column;
  max-width: 300px;
  align-items: end;
  margin-bottom: 20px;
  ${(props) =>
    props.view === "desktop"
      ? `
    @media (min-width: 1000px) {
      flex-direction: row;
      justify-content: space-between;
      gap: 15px;
    }
  `
      : `
    @media (min-width: 550px) {
      flex-direction: row;
      justify-content: space-between;
      gap: 15px;
    }
  `};
`;

export const RadioRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

export const RadioButtonWrapper = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: ${Color.White};
  border: 2px solid ${Color.BurntSienna};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

export const RadioButtonCenter = styled.div<RadioProps>`
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  ${(props) =>
    props.checked === true
      ? `background-color: ${Color.BurntSienna};`
      : `background-color: ${Color.White};`};
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  padding-left: 0;
  p {
    &:hover {
      cursor: pointer;
      color: ${Color.SeaBlue400};
    }
  }
  checkbox .checked {
    color: ${Color.SeaBlue400};
  }
`;

export const CheckboxText = styled.p`
  font-size: 14px;
  color: ${Color.MidnightBlue};
  font-family: ${FontFamily.MontserratSemiBold};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

type FilterHeaderProps = { $open: boolean };

export const FilterSectionHeader = styled.div<FilterHeaderProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 8px 0;
  border-bottom: ${(props) =>
    props.$open ? `1px solid ${Color.SeaBlue200}` : "none"};
  margin-bottom: ${(props) => (props.$open ? "12px" : "0")};
  user-select: none;
`;

export const ChevronIcon = styled.span<FilterHeaderProps>`
  display: inline-flex;
  transition: transform 0.2s ease;
  transform: rotate(${(props) => (props.$open ? "0deg" : "-90deg")});
  font-size: 1rem;
  color: ${Color.MidnightBlue};
`;

export const FilterBody = styled.div<FilterHeaderProps>`
  display: ${(props) => (props.$open ? "contents" : "none")};
`;
